import Header from './components/Header';
import Hero from './components/Hero';
import FAQ from './components/FAQ';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FAQ />
        <CardsSection />
        <ContactSection />
        <TopicsSection />
        <IndexSection />
        <MediaSection />
        <CommentsSection />
        <FeaturesSection />
        <UpdatesSection />
        <AppSection />
        <CarouselSection />
        <RankingSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}